module.exports = __webpack_public_path__ + "static/media/recommendation-logo.eb216a8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HeroRecommendation/recommendation-logo.png
// module id = 445
// module chunks = 0